import { MARKETING_SITE_URL } from '@/config/webOrigins';
import { HOME_PATH } from '@/components/useHasHome';
import X9Logo from '../components/X9Logo';

interface Props {
  title?: string;
  flagged?: boolean;
  declined?: boolean;
  /** Signed-in executors are sent back to their work instead of to marketing. */
  hasHome?: boolean;
}

export default function RunDoneStep({ title, flagged, declined, hasHome }: Props) {
  return (
    <div className="execute-screen items-center justify-center px-6 pb-[max(env(safe-area-inset-bottom),16px)] text-center">
      <div className="w-[min(25vw,5.7rem)] shrink-0 text-x9-marine">
        <X9Logo title="X9" className="block w-full select-none" />
      </div>
      <h1 className="mt-10 text-xl font-semibold tracking-tight text-x9-ink">
        {declined
          ? 'Run declined'
          : flagged
            ? 'Run finished — issues reported'
            : 'Run complete'}
      </h1>
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-x9-marineSoft">
        {declined
          ? 'The owner can reassign this run.'
          : title
            ? `${title} is with the owner.`
            : 'The owner can see every step you resolved.'}
      </p>
      {/*
        Pitching the app to someone who already signed in is a dead end where
        their next piece of work should be.
      */}
      {hasHome ? (
        <a
          href={HOME_PATH}
          className="btn-paper-primary mt-10 inline-flex w-full max-w-md items-center justify-center"
        >
          Back to your work
        </a>
      ) : (
        <a
          href={MARKETING_SITE_URL}
          className="btn-paper-primary mt-10 inline-flex w-full max-w-md items-center justify-center"
        >
          Get X9 at x9.app
        </a>
      )}
    </div>
  );
}
